import React from 'react'
import PropTypes from 'prop-types'

import BasePureComponent from 'utils/BasePureComponent'
import Input from 'components/Input'
import Button from 'components/Button'

import { MAKER_TYPE, BRAND_TYPE, MODEL_TYPE, BROKER_TYPE } from './constants'

import './style.scss'


const ITEMS = {
  [MAKER_TYPE]: {
    new: 'nueva',
    singular: 'marca',
    article: 'la',
    plural: 'marcas'
  },
  [BRAND_TYPE]: {
    new: 'nueva',
    singular: 'línea',
    article: 'la',
    plural: 'líneas'
  },
  [MODEL_TYPE]: {
    new: 'nuevo',
    singular: 'modelo',
    article: 'el',
    plural: 'modelos'
  },
  [BROKER_TYPE]: {
    new: 'nuevo',
    singular: 'agente',
    article: 'al',
    plural: 'agentes'
  },

}


export default class AddItemModal extends BasePureComponent {
  constructor(props) {
    super(props)
    const item = ITEMS[props.itemType]
    this.CONFIRM_KEY = `CREAR ${item.new.toUpperCase()} ${item.singular.toUpperCase()}`
    this.state = {
      confirmKey: '',
      buttonProps: {
        disabled: true
      }
    }
    this._bind('_closeModal', '_onChange', '_onConfirm')
  }

  _onChange(evt) {
    const confirmKey = (evt.target.value).toUpperCase()
    const buttonProps = confirmKey === this.CONFIRM_KEY ? {} : {disabled: true}
    this.setState({ confirmKey, buttonProps })
  }

  _closeModal() {
    this.context.hideSecondModal()
  }

  _onConfirm() {
    // we send back this.props.itemName to make sure that
    // what the user read is what its about to be POSTed
    this.props.onConfirm(this.props.itemName)
    this._closeModal()
  }

  render() {
    const item = ITEMS[this.props.itemType]
    return (
      <section className="AddVehicleItem">
        <div className="AddVehicleItem__header">
          <p>Agregar {item.singular}</p>
          <button className="material-icons" onClick={this._closeModal}>
            close
          </button>
        </div>
        <div className="AddVehicleItem__body">
          <p>¿Deseas agregar {item.article} {item.singular} <strong>"{this.props.itemName}"</strong> al listado general de {item.plural}?</p>
          <div className="AddVehicleItem__body--confirm-paragraphs">
            <p>Esta acción es irreversible, para continuar escribe</p>
            <p className="bold">{this.CONFIRM_KEY}</p>
          </div>

          <Input
            placeholder={this.CONFIRM_KEY}
            name="confirmKey"
            onChange={this._onChange}
            value={this.state.confirmKey}
          />
          <div className="AddVehicleItem__body-buttons">
            <Button  buttonType="danger" onClick={this._onConfirm} {...this.state.buttonProps}>
              <span>{this.CONFIRM_KEY}</span>
            </Button>
            <Button onClick={this._closeModal}>
              <span>CANCELAR</span>
            </Button>
          </div>
        </div>
      </section>
    )
  }
}

AddItemModal.propTypes = {
  itemType: PropTypes.oneOf([MAKER_TYPE, BRAND_TYPE, MODEL_TYPE, BROKER_TYPE]).isRequired,
  itemName: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired
}

AddItemModal.contextTypes = {
  hideSecondModal: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/AddItemModal/index.js